import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { TancadasTurnoContent } from "./components/TancadasTurnoContent";
import "./styles/TancadasTurno.css";

class TancadasTurno extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        const { match } = this.props;

        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "90vw", margin: "auto" }}
            >
                <Card
                    icon="produccion_activo"
                    titulo="Producción Sólidos"
                    subtitulo="Tancadas del turno"
                    noBorder
                >
                    <TancadasTurnoContent
                        turnoId={match.params.turno_id}
                        regresar={this.regresar}
                    />
                </Card>
            </div>
        );
    }
}

export default TancadasTurno;
